//#region States
import { useState } from "react";
//#endregion
//#region Styles
import { 
    Container, 
    GoToCompletedErrorStack } from "./styles";
//#endregion
//#region Components
import ErrorStack from "components/ErrorsStack/ErrorsStack";
//#endregion
//#region Icons
import ErrorIcon from "icons/ErrorIcon";
//#endregion
//#region Components
import Message from "components/Message/Message";
import ErrorStackDialog from "components/ErrorStackDialog/ErrorStackDialog";
import NotifyImportantMessage from "components/NotifyImportantMessage/NotifyImportantMessage";
//#endregion

const FileErrorsBlock = ({
    errorStack
}) => {
    //#region States
    const [showErrorStackDialog, setShowErrorStack] = useState(false);
    //#endregion
    //#region Functions
    const toggleShowErrorStackDialog = (value = null) => {
        setShowErrorStack(value == null ? !showErrorStackDialog : value);
    }
    //#endregion
    const { stack, rowCountFile } = errorStack;
    return (
        <Container>
            <Message 
                success={false} 
                quantityErrors={stack.length}
                quantityRows={rowCountFile}/>
            {stack.length > 0 && <ErrorStack stack={stack}/>}
            {stack.length > 10 && 
                <GoToCompletedErrorStack>
                    <div>
                        <ErrorIcon/>
                    </div>
                    <span>
                        Has superado los 10 errores, revísalo detalladamente.  <strong onClick={() => setShowErrorStack(true)}>Ver lista de errores</strong>
                    </span>
                </GoToCompletedErrorStack>}
            <NotifyImportantMessage message="Si quisieras tomarte una pausa o salir de esta ventana, tendrás que volver a empezar el proceso para ver tus errores."/>
            <ErrorStackDialog 
                show={showErrorStackDialog}
                toggleShow={toggleShowErrorStackDialog}
                errorStack={stack}/>
        </Container>
    );
}

export default FileErrorsBlock;